export const RequestDemoLoader = ({ className = '', gray = false }) => (
  <div className={`request-demo-loader ${className} ${gray ? 'gray' : ''}`} />
);
